module.exports = __webpack_public_path__ + "static/img/frame-quesion-mark.3e25a117.png";